import axios from 'axios'
axios.defaults.timeout = 30000 // 设置超时时长
axios.defaults.baseURL = ''
// http request 拦截器
axios.interceptors.request.use(
    (config) => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 404:
                    console.log('找不到該頁面')
                    break
                case 500:
                    console.log('伺服器出錯')
                    break
                case 503:
                    console.log('服務失效')
                    break
                default:
                    console.log(`連接錯誤${error.response.status}`)
            }
        } else {
            console.log('連接到服務器失敗')
        }
        return Promise.reject(error.response)
    }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
        .then(response => {
            resolve(response.data)
        })
        .catch(err => {
            reject(err)
        })
    })
}

/**
 * POST
 * @param url
 * @returns {Promise}
 */
 export function post(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(
            res => {
                resolve(res.data)
            },
            err => {
                reject(err)
            }
        ).catch(e => {
            reject(e)
        })
    })
}